export const PLACEHOLDER = Object.freeze({
  TO: '받는 사람 이름을 입력해 주세요.',
  FROM: '이름을 입력해 주세요.',
});

export const CONFIRM_MESSAGE = Object.freeze({
  DELETE_CARD: '정말로 이 카드메시지를 삭제하시겠어요?',
  DELETE_ROLLING: '정말로 이 롤링페이퍼를 삭제하시겠어요?',
});
